module.exports = __webpack_public_path__ + "img/ACDC_TOUR_15v1 16-9.61c90cc2.jpg";